<osn-cxb-dialog [title]="data.variant === ContentGroupDetailDialogVariant.NEW ? 'Create new content group' : 'Content group metadata'">
  <form [formGroup]="form" class="d-flex flex-column">
    <mat-form-field>
      <input
        trim="blur"
        matInput
        type="text"
        placeholder="Content group name"
        autocomplete="off"
        formControlName="name"
        data-testid="content-group-screen-edit-dialog-name-input"
      />
      <mat-error *ngIf="nameCtrlHasError">Content group name is required</mat-error>
    </mat-form-field>
    <mat-form-field class="mt-4">
      <input
        trim="blur"
        matInput
        type="text"
        placeholder="Content group description"
        autocomplete="off"
        formControlName="description"
        data-testid="content-group-screen-edit-dialog-description-input"
      />
    </mat-form-field>
    <div class="actions mt-4 d-flex justify-content-center">
      <button
        *ngIf="data.variant === ContentGroupDetailDialogVariant.NEW; else editActions"
        class="create-btn"
        type="button"
        [disabled]="form.invalid || !form.dirty"
        (click)="onCreateClick()"
        data-testid="content-group-screen-edit-dialog-create-btn"
      >
        Create content group
      </button>
      <ng-template #editActions>
        <button type="button" class="secondary mr-3 cancel-btn" (click)="onCancelClick()">Cancel</button>
        <button
          type="button"
          class="save-btn"
          [disabled]="form.invalid || !form.dirty"
          (click)="onSaveClick()"
          data-testid="content-group-screen-edit-dialog-save-btn"
        >
          Save changes
        </button>
      </ng-template>
    </div>
  </form>
</osn-cxb-dialog>
